export * from './AppStatus';
export * from './Environment';

export const MAX_MESSAGES = 3;

export const HELP_LINK = 'https://contentcapabilities.com/salesforce-marketing-cloud-integration-with-promomats/';
